import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'batp-profile-pro',
  templateUrl: './profile-pro.component.html',
  styleUrls: ['./profile-pro.component.css']
})
export class ProfileProComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
